import { environment } from "../../../environments/environment";
export const IDLETIMES = {
  timeout: environment.timeoutParams.timeout, //tiempo en minutos que se tolera no realizar ninguna acción en programmate
  countdown: environment.timeoutParams.lastCount, // cuenta regresiva final para cierre de sesión por inactividad en programmate
};

export const MAXTRIESPROPUESTA = 50;
